import { z } from 'zod';
import { categoryIdSchema } from './ids';
import { rateOrInheritSchema } from './rate';
import { scheduledSchema } from './scheduled';

export const CATEGORY_KINDS = ['income', 'expense'] as const;
export type CategoryKind = (typeof CATEGORY_KINDS)[number];

export const categorySchema = z.object({
  id: categoryIdSchema,
  name: z.string().trim().min(1).max(80),
  kind: z.enum(CATEGORY_KINDS),
  /**
   * Default inflation for indexed items in this category (e.g. housing at CPI + 1 %).
   * Omitted or `inherit` periods fall back to the global CPI.
   */
  inflation: scheduledSchema(rateOrInheritSchema).optional(),
});
export type Category = z.infer<typeof categorySchema>;
